const NumberFormatterRegex = /\B(?=(\d{3})+(?!\d))/g

export const numberWithCommas = (number: string | number) => {
  return number.toString().replace(NumberFormatterRegex, ',')
}

// Zero-width space after each comma — an optional break point, only used if the number doesn't fit
export const withCommaBreaks = (value: string) => value.replace(/,/g, ',\u200B')
